export const shippingOptions: ShippingOption[] = [
    {
        id: 'standard',
        label: 'Standard',
        description: '5-7 business days',
        stripe_price_id: '',
        price: 0,
        value: 'standard',
    },
    {
        id: 'expedited',
        label: 'Expedited',
        stripe_price_id: 'price_1OUdpoIDrm6Z6HgYgMJz6wZf', // production price
        description: '2-3 business days',
        price: 1995,
        value: 'expedited',
    },
]

export default shippingOptions
